import { render } from "./ClubAmountDueDetails.vue?vue&type=template&id=3522166d"
import script from "./ClubAmountDueDetails.vue?vue&type=script&lang=js"
export * from "./ClubAmountDueDetails.vue?vue&type=script&lang=js"

import "./ClubAmountDueDetails.vue?vue&type=style&index=0&id=3522166d&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__